<div class="modal-header">
  <div class="row">
    <div class="header">
      <span
        #inputTitle
        class="title text editable-span"
        [contentEditable]="true"
        (blur)="title = inputTitle.innerText"
        (keydown.enter)="onTitleEnterKey($event)"
        type="text"
        placeholder="Note title"
      >
        <i
          *ngIf="title"
          style="
            margin-left: 4px;
            pointer-events: none;
            opacity: 0.32;
            font-size: 1rem;
            position: relative;
            top: -1px;
          "
          class="tio-edit"
        ></i>
      </span>
    </div>
    <!-- <div class="col-sm-6"></div> -->
  </div>
  <button
    type="button"
    class="btn-close"
    (click)="bsModalRef.hide()"
    aria-label="Close"
  >
    <i class="feather x"></i>
  </button>
</div>
<div class="modal-body" style="background-color: #fff">
  <p-editor #rte [(ngModel)]="content" [style]="{ height: '320px' }">
    <p-header>                         
      <span class="ql-formats">
        <select class="ql-font ql-picker">
          <option selected>Sans Serif</option>
          <option value="serif">Serif</option>
          <option value="monospace">Monospace</option>
        </select>
      </span>                 
      <span class="ql-formats">
        <button class="ql-bold" aria-label="Bold"></button>
        <button class="ql-italic" aria-label="Italic"></button>
        <button class="ql-underline" aria-label="Underline"></button>
        <button class="ql-strike" aria-label="Strike"></button>
      </span>
      <span class="ql-formats">
        <select title="Text Color" class="ql-color" defaultValue="rgb(0, 0, 0)">
        </select>
        <span class="ql-format-separator"></span>
        <select title="Background Color" class="ql-background" defaultValue="rgb(255, 255, 255)">
        </select>
      </span>
      <span class="ql-formats">
        <button class="ql-list" value="ordered" type="button"></button>
        <button class="ql-list" value="bullet" type="button"></button>
      </span>
      <span class="ql-formats">
        <button aria-label="Link" class="ql-link"></button>
        <button aria-label="Image" class="ql-image"></button>
      </span>
    </p-header> 
  </p-editor>

  <div class="modal-footer">
    <div class="row">
      <div class="col-sm-6 text-left">
        <button
          class="btn btn-default buttons text"
          style="background: #b0b2b5"
          (click)="cancel()"
        >
          Cancel
        </button>
      </div>
      <div class="col-sm-6">
        <button class="btn btn-primary buttons text" (click)="confirm()">
          Create note
        </button>
      </div>
    </div>
  </div>
</div>
